import apiClient from "./api";

class ReportsService {
  /**
   * Get sales report with filtering and grouping options
   */
  async getSalesReport(params: {
    start_date: string;
    end_date: string;
    group_by?: "day" | "week" | "month";
    status_id?: number;
    order_type?: string;
  }): Promise<any> {
    return await apiClient.get<any>("/reports/sales", { params });
  }

  /**
   * Get items sold report
   */
  async getItemsSoldReport(params: {
    start_date: string;
    end_date: string;
    category_id?: number;
    limit?: number;
  }): Promise<any> {
    return await apiClient.get<any>("/reports/items-sold", { params });
  }

  /**
   * Get revenue report
   */
  async getRevenueReport(
    params: {
      period?: "daily" | "weekly" | "monthly";
      year?: number;
      month?: number;
    } = {},
  ): Promise<any> {
    return await apiClient.get<any>("/reports/revenue", { params });
  }

  /**
   * Get delivery performance report
   */
  async getDeliveryReport(params: {
    start_date: string;
    end_date: string;
    driver_id?: number;
  }): Promise<any> {
    return await apiClient.get<any>("/reports/delivery", { params });
  }

  /**
   * Get operational costs report
   */
  async getOperationalCostsReport(params: {
    start_date: string;
    end_date: string;
  }): Promise<any> {
    return await apiClient.get<any>("/reports/operational-costs", { params });
  }

  /**
   * Export report to CSV
   * This is a hypothetical method - the API would need to support this
   */
  async exportReportToCsv(reportType: string, params: any): Promise<Blob> {
    return await apiClient.get<Blob>(`/reports/${reportType}/export`, {
      params,
      responseType: "blob",
    });
  }

  /**
   * Generate custom report
   * This is a hypothetical method - the API would need to support this
   */
  async generateCustomReport(config: {
    report_type: string;
    metrics: string[];
    dimensions: string[];
    filters: Record<string, any>;
    start_date: string;
    end_date: string;
  }): Promise<any> {
    return await apiClient.post<any>("/reports/custom", config);
  }
}

// Create singleton instance
export const reportsService = new ReportsService();
